export default {
  POSTER_HORIZONTAL:
    'https://img01.71360.com/file/read/www/M00/E9/BA/wKj0iWKdtAyAWc6qAAD-bHP41Ms171.png',
  POSTER_VERTICAL:
    'https://img01.71360.com/file/read/www/M00/E9/BA/wKj0iWKdtAyAQVJwAANe62kLhjw378.png',
}
